exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".groups[data-v-10e9c376]{display:flex;justify-content:stretch;margin-top:50px;margin-right:50px}.group[data-v-10e9c376]{margin-left:50px;flex:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10e9c376","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/groups.vue
// module id = 66
// module chunks = 0